import inView from 'in-view';

const timeline = (widget = null) => {

  inView('.c-timeline')

    .on('enter', el => {
      el.classList.add('c-timeline--animate');
    })
}
timeline();
window.timeline = timeline
